import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { boxStyle } from "../../../consts/styles";
import { TableComponents, TableVirtuoso } from "react-virtuoso";
import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

interface Data {
  id: number;
  distinct_member: number;
  total_calories: number;
}
interface ColumnData {
  dataKey: keyof Data;
  label: string;
  numeric?: boolean;
  width: number;
}

var columns: ColumnData[] = [
  {
    width: 100,
    label: "เขต",
    dataKey: "id",
  },
  {
    width: 100,
    label: "จำนวนคนที่ส่ง (คน)",
    dataKey: "distinct_member",
  },
  {
    width: 100,
    label: "แคลอรี่",
    dataKey: "total_calories",
  },
];

const VirtuosoTableComponents: TableComponents<any> = {
  Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
    <TableContainer
      sx={{ boxShadow: "none", borderRadius: 0 }}
      {...props}
      ref={ref}
    />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead,
  TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
  TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
};

const fixedHeaderContent = () => {
  return (
    <TableRow>
      {columns.map((column: any) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="center"
          style={{ width: column.width }}
          sx={{
            padding: "10px 0",
            backgroundColor: "#EB698F",
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 600 }} color="white">
            {column.label}
          </Typography>
        </TableCell>
      ))}
    </TableRow>
  );
};

const rowContent = (_index: number, row: any) => {
  return (
    <React.Fragment>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          align="center"
          sx={{
            borderBottom: "none",
            background: _index % 2 !== 0 ? "#F5F7FA" : "",
          }}
        >
          {column.dataKey === "id" && (
            <Typography variant="subtitle2" color="black.main">
              เขตสุขภาพที่ {row[column.dataKey]?.toLocaleString()}
            </Typography>
          )}

          {column.dataKey !== "id" && (
            <Typography variant="subtitle2" color="black.main">
              {row[column.dataKey]?.toLocaleString()}
            </Typography>
          )}
        </TableCell>
      ))}
    </React.Fragment>
  );
};

const CaloriesByZone = ({ areaSummaries }: any) => {
  return (
    <Box sx={boxStyle}>
      <Typography
        align="center"
        typography={{ xs: "h4", sm: "h3" }}
        color="black.main"
      >
        แคลอรี่รายเขตสุขภาพ
      </Typography>

      <Box display="flex" gap="16px">
        <Box
          sx={{
            width: 1,
            height: 400,
            background: "#FFFFFF",
            borderRadius: "10px",
          }}
        >
          <TableVirtuoso
            data={areaSummaries}
            components={VirtuosoTableComponents}
            fixedHeaderContent={fixedHeaderContent}
            itemContent={rowContent}
          />
        </Box>

        <Box display="flex" width={1} margin="10px">
          <ResponsiveContainer width={"100%"} height={400}>
            <BarChart
              layout="vertical"
              width={400}
              height={400}
              data={areaSummaries}
              margin={{
                top: 10,
                right: 30,
                left: 30,
                bottom: 0,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                type="number"
                tickFormatter={(value) => value.toLocaleString()}
                tick={{ fontSize: 12 }}
              />
              <YAxis
                dataKey="id"
                type="category"
                tick={<CustomizedAxisTick />}
                interval={0}
              />
              <Bar dataKey="total_calories" fill="#A8E1D4">
                <LabelList
                  dataKey="total_calories"
                  position="insideRight"
                  style={{ fill: "#151617", fontSize: "12px" }}
                  formatter={(value: any) => value.toLocaleString()}
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </Box>
    </Box>
  );
};

const CustomizedAxisTick = ({ x, y, payload }: any) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
        style={{ fontSize: "12px", fontWeight: 600 }}
      >
        เขตสุขภาพที่ {payload.value}
      </text>
    </g>
  );
};

export default CaloriesByZone;
